import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { SharedHero } from '@hover/shared-components';
import {
  HoInvitedReadyToStart,
  Layout,
  NewsLetterBar,
  UtilityMenuBanner,
} from '../../v2/components/common';

import {
  BetterSection,
  BetterWayToBuild,
} from '../../v2/components/invited-by-contractor';

const InvitedByContractor: React.FC = () => (
  <Layout
    showDivider={false}
    title="Invited by contractor"
    bannerElement={<UtilityMenuBanner />}
  >
    <SharedHero
      heading="Why did my contractor invite me to use HOVER?"
      body="HOVER quickly transforms photos of your home into a 3D model so
      you can easily visualize your project and know exactly what it will cost
       before the work begins—good contractor, huh?"
      backgroundColor="brandNavy.500"
      haveBackground
      haveContentChildren={false}
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          alt="invited by contractor hero"
          src="../../v2/assets/images/invited_by_contractor_hero_desktop.png"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          alt="invited by contractor hero"
          src="../../v2/assets/images/invited_by_contractor_hero_tablet.png"
        />
      }
      page="invited-by-contractors"
    />
    <BetterSection />
    <BetterWayToBuild
      header="You’re only a few minutes from a better way to build."
      description="Fast, simple, secure and free. Did we mention the free part?"
    />
    <HoInvitedReadyToStart backgroundColor="brandNavy.500" />
    <NewsLetterBar iconColor="brandYellow.500" bg="brandGreen.500" />
  </Layout>
);

export default InvitedByContractor;
